import { IQueuePositionManager, ScrollDirection } from '../types.d';

export default class DownQpm implements IQueuePositionManager {
  direction = ScrollDirection.Down;
  isBefore: IQueuePositionManager['isBefore'] = (a, b) => a < b;
  getTrigger: IQueuePositionManager['getTrigger'] = (triggers) =>
    triggers === null ? null : triggers.down;
}
